var _rect, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLisIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 36,
    height: 36,
    rx: 18,
    fill: "#6576FF"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_12975_180473)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M25.2164 11.4886L19.4104 8.08813C19.0577 7.87403 18.554 8.06294 18.3021 8.50375C18.0502 8.94455 18.1258 9.47352 18.491 9.68763L18.894 9.92692L10.821 23.6801C10.4557 24.2972 10.3298 25.0529 10.5313 25.8085C10.7328 26.5516 11.2114 27.1561 11.8285 27.5214L12.0048 27.6221C12.622 27.9874 13.3776 28.1133 14.1333 27.9118C14.8764 27.7103 15.4809 27.2317 15.8462 26.6146L23.9066 12.8488L24.3096 13.0881C24.6749 13.3022 25.1786 13.1133 25.4305 12.6725C25.6698 12.2191 25.5817 11.6901 25.2164 11.4886ZM19.5615 19.0579L15.5817 16.7405L19.3978 10.2292L23.365 12.5466L19.5615 19.0579Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_12975_180473"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 15.1133,
    height: 20,
    fill: "white",
    transform: "translate(10.4434 8)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLisIcon);
export default __webpack_public_path__ + "static/media/LIS_icon.ca0710c8.svg";
export { ForwardRef as ReactComponent };